module.exports = __webpack_public_path__ + "img/b4.cbc88319.png";